import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../icons/components/Icon';
import { BUTTON_TYPES } from '../../constants.web';
import { withPixelLineHeight } from "../../../styles/functions.web";
const useStyles = makeStyles()(theme => {
    return {
        button: {
            backgroundColor: theme.palette.iisightBrandBackground,
            color: theme.palette.iisightWhiteText,
            borderRadius: "3px",
            padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: 0,
            ...withPixelLineHeight(theme.typography.bodyShortBold),
            transition: "background .2s",
            cursor: "pointer",
            "&:hover": {
                backgroundColor: theme.palette.iisightBrand700
            },
            "&:active": {
                backgroundColor: theme.palette.iisightDarkBrandBackground
            },
            "&.focus-visible": {
                outline: 0,
                boxShadow: `0px 0px 0px 2px ${theme.palette.focus01}`
            },
            "& div > svg": {
                fill: theme.palette.icon01
            }
        },
        primary: {},
        secondary: {
            backgroundColor: theme.palette.iisightBlue500,
            color: theme.palette.iisightWhite,
            "&:hover": {
                backgroundColor: theme.palette.iisightBlue700
            },
            "&:active": {
                backgroundColor: theme.palette.iisightBlue900
            },
            "& div > svg": {
                fill: theme.palette.icon04
            }
        },
        tertiary: {
            fill: theme.palette.iisightDefaultText,
            color: theme.palette.iisightDefaultText,
            backgroundColor: "transparent",
            "&:hover": {
                fill: theme.palette.iisightWhite,
                color: theme.palette.iisightWhite,
                backgroundColor: theme.palette.iisightGray200
            },
            "&:active": {
                fill: theme.palette.iisightGray100,
                color: theme.palette.iisightGray100,
                backgroundColor: theme.palette.iisightGray700
            }
        },
        destructive: {
            backgroundColor: theme.palette.actionDanger,
            "&:hover": {
                backgroundColor: theme.palette.actionDangerHover
            },
            "&:active": {
                backgroundColor: theme.palette.actionDangerActive
            }
        },
        disabled: {
            backgroundColor: theme.palette.disabled01,
            color: theme.palette.text03,
            "&:hover": {
                backgroundColor: theme.palette.disabled01,
                color: theme.palette.text03
            },
            "&:active": {
                backgroundColor: theme.palette.disabled01,
                color: theme.palette.text03
            },
            "& div > svg": {
                fill: theme.palette.icon03
            }
        },
        iconButton: {
            padding: theme.spacing(2)
        },
        textWithIcon: {
            marginLeft: theme.spacing(2)
        },
        small: {
            padding: "8px 16px",
            ...withPixelLineHeight(theme.typography.labelBold),
            "&.iconButton": {
                padding: theme.spacing(1)
            }
        },
        medium: {},
        large: {
            padding: "13px 16px",
            ...withPixelLineHeight(theme.typography.bodyShortBoldLarge),
            "&.iconButton": {
                padding: "12px"
            }
        },
        fullWidth: {
            width: "100%"
        }
    };
});
const Button = React.forwardRef(({ accessibilityLabel, autoFocus = false, className, disabled, fullWidth, icon, id, isSubmit, label, labelKey, onClick = () => null, onKeyPress = () => null, size = 'medium', testId, type = BUTTON_TYPES.PRIMARY }, ref) => {
    const { classes: styles, cx } = useStyles();
    const { t } = useTranslation();
    return (React.createElement("button", { "aria-label": accessibilityLabel, autoFocus: autoFocus, className: cx(styles.button, styles[type], disabled && styles.disabled, icon && !(labelKey || label) && `${styles.iconButton} iconButton`, styles[size], fullWidth && styles.fullWidth, className), "data-testid": testId, disabled: disabled, ...(id ? { id } : {}), onClick: onClick, onKeyPress: onKeyPress, ref: ref, title: accessibilityLabel, type: isSubmit ? 'submit' : 'button' },
        icon && React.createElement(Icon, { size: 24, src: icon }),
        (labelKey || label) && React.createElement("span", { className: icon ? styles.textWithIcon : '' }, labelKey ? t(labelKey) : label)));
});
export default Button;
